import { SagaIterator } from 'redux-saga';
import { all, AllEffect, call, ForkEffect, put, takeEvery } from 'redux-saga/effects';
import {
  ConsentsActionTypes,
  getConsentsError,
  getConsentsSuccess,
  UpdateConsentsAction,
  updateConsentsError,
  updateConsentsSuccess,
} from '../actions/consentsActions';
import BffApiService from '@/shared/bffApiService';

export function* getConsentsSaga(): SagaIterator {
  try {
    const response = yield call(BffApiService.getConsents);
    yield put(getConsentsSuccess(response.data.data));
  } catch (error) {
    yield put(getConsentsError());
  }
}

export function* updateConsentsSaga(action: UpdateConsentsAction): SagaIterator {
  try {
    const response = yield call(BffApiService.updateConsents, { payload: action.payload });
    yield put(updateConsentsSuccess(response.data.data));
  } catch (error) {
    yield put(updateConsentsError());
  }
}

export function* watchConsents(): Generator<AllEffect<ForkEffect<never>>, void> {
  yield all([takeEvery(ConsentsActionTypes.GetConsents, getConsentsSaga)]);
  yield all([takeEvery(ConsentsActionTypes.UpdateConsents, updateConsentsSaga)]);
}
